import React from "react";
import classes from "../ButtonLink/ButtonLink.module.scss";
import { Link } from "react-router-dom";

const ButtonBack = ({ size, rounded, to, className = classes.ButtonBacks, disabled = false, text, children }) => {

  // Check the button size

  if (disabled) {
    return (
      <span className={`${className} ${classes.ButtonDisabled}`}>
        <span>{children ? children : text ? text : null}</span>
      </span>
    );
  }

  return (
    <Link to={to ? to : "/"} className={className}>
      <span>{children ? children : text ? text : null}</span>
    </Link>
  );
};

export default ButtonBack;
